import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import { useLocalizationStore } from './LocalizationStore.js'
import { useUserStore } from './UserStore.js'

export const useBillingStore = defineStore('BillingStore', {
    state: () => {
        return {
            subscriptionPlan: ref({}),
            invoices: ref({}),
            btnClicked:ref(1),
            error:ref({}),
            applying:ref('false'),
            couponBtn:ref('Apply Coupon'),
            subscriptionLoading:ref(true),
            route: useRoute(),
            router: useRouter(),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            END_TRIAL_START_SUBSCRIPTION: 0,
            END_TRIAL: 1,
            CANCEL_SUBSCRIPTION: 2,
            SUBSCRIPTION_STATUSES: {
                OTHER: 0,
                ACTIVE: 1,
                CANCELED: 2,
                ENDED: 3,
                INCOMPLETE: 4,
                NOT_CANCELED: 5,
                NOT_ON_GRACE_PERIOD: 6,
                NOT_ON_TRIAL: 7,
                ON_GRACE_PERIOD: 8,
                ON_TRIAL: 9,
                PAST_DUE: 10,
                RECURRING: 11,
            },
            cards: {
                'mastercard': 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/cards/mastercard.png',
                'visa': 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/cards/visa.png',
                'amex': 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/cards/american-express.png',
                'discover': 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/cards/discover.png',
            }
        }
    },
    actions: {
        async getSubscriptionPlan() {
            try {
                let $this = this;
                const route = this.router.resolve(
                    {
                        name: 'billing-subscriptions-plan'
                    }
                );
                this.subscriptionPlan = await axios.post(route.href)
                .then(function (response) {
                    $this.subscriptionLoading = false;
                    return response.data.data;
                });

            } catch (error) {

            }
        },
        async getInvoice() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'billing-subscriptions-invoices'
                    }
                );
                this.invoices = await axios.post(route.href)
                .then(function (response) {
                    return response.data.data;
                });

            } catch (error) {

            }
        },
        cancelSubscription(cancelType) {
            const message = {
                0: 'Yes, Start Subscription!',
                1: 'Yes, End Trial!',
                2: 'Yes, Cancel Subscription!'
            }
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: message[cancelType],
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'cancel-subscriptions',
                        }
                    );
                    axios.post(
                        route.href,
                        {
                            cancelType: cancelType
                        }
                    )
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        setTimeout(() => {window.location.reload();}, 1000)
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        deleteCard(id) {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: $this.localizationStore.translate('delete.card.confirm.message'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'purchase-delete-card',
                        }
                    );
                    axios.post(
                        route.href,
                        {
                            id: id
                        }
                    )
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        let index = _.findIndex($this.userStore.profile.payment_methods, function(paymentMethod) { return paymentMethod.id == id; });
                        $this.userStore.profile.payment_methods.splice(index, 1);
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        defaultCard(id) {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: $this.localizationStore.translate('default.card.confirm.message'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'purchase-default-card',
                        }
                    );
                    axios.post(
                        route.href,
                        {
                            id: id
                        }
                    )
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.userStore.profile.default_payment_method = response.data.data.default_payment_method;
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
    },
    getters: {
        translate: (state) => {

        },
    },
})
